var styleDataHash = "ef0c400a";
const injectCss = () => {
  var css = `.JJ1qT{height:100%;position:absolute;top:0;width:100%;z-index:0}[dir] .JJ1qT{border:0}[dir=ltr] .JJ1qT{left:0}[dir=rtl] .JJ1qT{right:0}.MpRRB{bottom:0;position:absolute;top:0;z-index:3}[dir=ltr] .MpRRB,[dir=rtl] .MpRRB{left:0;right:0}.b4dUG{height:0;position:relative}[dir] .b4dUG{padding-bottom:56.25%}@supports not (contain:inline-size){@media only screen and (max-width:640px){.b4dUG{min-width:auto}}}@container (width < 640px){.b4dUG{min-width:auto}}.MRBKO{bottom:0;height:100%;position:absolute;top:0;width:100%;z-index:1}[dir] .MRBKO{cursor:move}.MRBKO~*>*{pointer-events:none}.RFsVr{height:0;overflow:hidden;visibility:hidden;width:0}.RFsVr,.mostI{position:absolute}.mostI{align-items:center;color:#fff;display:flex;font-size:20px;font-weight:400;height:100%;justify-content:center;top:0;width:100%;z-index:1}[dir] .mostI{background:rgba(0,0,0,.5);text-align:center}[dir=ltr] .mostI{right:0}[dir=rtl] .mostI{left:0}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var default_video_styles_default = {
  "video_player": "JJ1qT",
  "videoOverlay": "MpRRB",
  "video_container": "b4dUG",
  "video_overlay": "MRBKO",
  "hide_duration": "RFsVr",
  "error": "mostI"
};
export {
  default_video_styles_default as default,
  injectCss
};
//# sourceMappingURL=default-video-styles-scss.js.map
